/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon32Regular = forwardRef('BookClosedIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11 9a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2a5 5 0 0 0-5 5v19.5A3.5 3.5 0 0 0 8.5 30H26a1 1 0 1 0 0-2H8.5a1.5 1.5 0 0 1 0-3H24a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H10ZM8.5 23c-.537 0-1.045.12-1.5.337V7a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H8.5Z" })));
});
